export default __webpack_public_path__ + "static/media/logo-full-white.533e13cb.svg";